module.exports = __webpack_public_path__ + "static/media/heroIllustration.29e701ac.png";